export function initCatalogFilter() {
    const filter = document.querySelector('#filter-menu-wrapper');
    if (filter && window.innerWidth < 575.98 && BX.browser.IsMobile()) {
        const menuFilter = document.getElementById('menuFilter');
        const menuPanel = document.querySelector('.menu-panel__filter');

        menuFilter.append(filter);
        menuPanel.classList.add('show');

    }
}
